import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import styles from './Currency.module.sass';
import Icon from '../../../components/Icon';
import { FaStar } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { coinIcons } from '../CurrencyHelper/currenciesIcons';
import { getFavorites, handleFavorite } from '../CurrencyHelper/favourite';
import { navigation } from '../CurrencyHelper/navigation';
import CurrencyRow from '../CurrencyHelper/CurrencyRow';
import { AutoSizer, List } from 'react-virtualized';
import AppLoader from '../../../components/AppLoader/index.js';

const Currency = ({ onMarketSelect }) => {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(0);
  const [search, setSearch] = useState('');
  const [favoritesData, setFavoritesData] = useState([]);

  const markets = useSelector((state) => state.crypto.markets.markets);

  // Update favorites based on local storag e
  const updateFavorites = () => {
    const favorites = getFavorites();
    const favoriteMarkets = markets?.filter((market) => favorites.includes(market._id));
    setFavoritesData(favoriteMarkets);
  };

  // Update favorites every time the markets change or a favorite is toggled
  useEffect(() => {
    updateFavorites();
  }, [markets]);

  // Filter markets based on the active tab and search term
  const filteredMarkets = markets
    ?.filter((market) => {
      const matchesSearch = market?.pairName
        ?.toLowerCase()
        .includes(search.replace(/-/g, '/').toLowerCase());
      if (activeIndex === 0 || activeIndex === 2) {
        // All and Top: show all markets (filtered by search)
        return matchesSearch;
      }
      if (activeIndex === 1) {
        // Favorite: show only markets in favorites that match the search
        const isFav = favoritesData.some((fav) => fav?._id === market?._id);
        return isFav && matchesSearch;
      }
      return false;
    })
    .sort((a, b) => {
      if (activeIndex === 2) {
        // Top: sort by price descending
        const priceA = parseFloat(a.currentPrice?.$numberDecimal || a.currentPrice || 0);
        const priceB = parseFloat(b.currentPrice?.$numberDecimal || b.currentPrice || 0);
        return priceB - priceA;
      }
      return 0;
    });

if (!markets || markets.length === 0) {
      return <AppLoader/>
    }
  return (
    <div className={styles.currency}>
      <div className={styles.nav}>
        {navigation?.map((item, index) => (
          <button
            className={cn(styles.link, { [styles.active]: index === activeIndex })}
            onClick={() => setActiveIndex(index)}
            key={index}
          >
            {t(item)}
          </button>
        ))}
      </div>
      <div>
        <input
          className={styles.input}
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          name="search"
          placeholder="Search"
          required
        />
      </div>
      <div className={styles.table}>
        <div className={styles.row}>
          <div className={styles.col}>
            <div className="sorting">Pair</div>
          </div>
          <div className={styles.col}>
            <div className="sorting">Price</div>
          </div>
        </div>
        <AutoSizer disableHeight>
  {({ width }) => (
    <List
      width={width}
      // Let the parent scroll instead of List
      height={filteredMarkets.length * 50} 
      rowHeight={50}
      rowCount={filteredMarkets?.length || 0}
      style={{ overflowY: "visible", overflowX: "hidden" }} // prevent inner scrollbar and x overflow
      rowRenderer={({ index, key, style }) => {
        const x = filteredMarkets[index];

        // cache last known data per market to prevent NaN
        if (!Currency.cached) Currency.cached = {};
        const cache = Currency.cached;

        if (x) {
          cache[x._id] = x; // update cache
        }

        const safeData = x || cache[x?._id];

        return (
          <div key={key} style={style}>
            <CurrencyRow
              data={safeData}
              onMarketSelect={onMarketSelect}
              onFavoriteToggle={updateFavorites}
            />
          </div>
        );
      }}
    />
  )}
</AutoSizer>

      </div>
    </div>
  );
};

export default Currency;
